import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	modal: {
		zIndex: 9999,
	},
	header: {
		display: 'flex',
		alignItems: 'flex-end',
		justifyContent: 'flex-end',
	},
	iconContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		marginTop: 20,
		marginBottom: 24,
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		paddingInline: THEME.spacing.md,
		paddingBottom: THEME.spacing.md,
	},
	aiButtonContainer: {},
	contentText: {
		textAlign: 'center',
		marginTop: 0,
		marginBottom: 32,
	},
	actionsContainer: {
		display: 'flex',
		justifyContent: 'center',
		gap: THEME.spacing.md,
		marginBottom: 24,
	},
	aiButtonText: {
		fontSize: 16,
		color: THEME.colors.primary.main,
	},
	newTag: {
		fontWeight: 600,
	},
});
